import { useExpondoMiddleware } from '~/composables';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';
import { Address, Customer, CustomQuery } from '~/types/commercetools';

export function useUserShippingApi() {
  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  const addCustomerAddress = async (
    {
      address,
      customer,
      customQuery,
    }: {
      address: Partial<Address>,
      customer: Partial<Customer>,
      customQuery?: CustomQuery,
    },
  ): Promise<Customer | undefined> => {
    const response = await makeCommercetoolsRequest<{ user: Customer }>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.ADD_CUSTOMER_SHIPPING_ADDRESS,
      data: [
        customer,
        address,
        customQuery,
      ],
    });
    return response?.data?.user;
  };

  const deleteCustomerAddress = async (
    {
      address,
      customer,
    }: {
      address: Partial<Address>,
      customer: Partial<Customer>,
    },
  ): Promise<Customer | undefined> => {
    const response = await makeCommercetoolsRequest<{ user: Customer }>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.DELETE_CUSTOMER_SHIPPING_ADDRESS,
      data: [
        customer,
        address,
      ],
    });
    return response?.data?.user;
  };

  const updateCustomerAddress = async (
    {
      address,
      customer,
      customQuery,
    }: {
      address: Partial<Address>,
      customer: Partial<Customer>,
      customQuery?: CustomQuery,
    },
  ): Promise<Customer | undefined> => {
    const response = await makeCommercetoolsRequest<{ user: Customer }>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.UPDATE_CUSTOMER_SHIPPING_ADDRESS,
      data: [
        customer,
        address,
        customQuery,
      ],
    });
    return response?.data?.user;
  };

  const setDefaultCustomerAddress = async (
    {
      address,
      customer,
      customQuery,
    }: {
      address: Partial<Address>,
      customer: Partial<Customer>,
      customQuery?: CustomQuery,
    },
  ): Promise<Customer | undefined> => {
    const response = await makeCommercetoolsRequest<{ user: Customer }>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.SET_DEFAULT_CUSTOMER_SHIPPING_ADDRESS,
      data: [
        customer,
        address,
        customQuery,
      ],
    });
    return response?.data?.user;
  };

  return {
    addCustomerAddress,
    deleteCustomerAddress,
    updateCustomerAddress,
    setDefaultCustomerAddress,
  };
}
